export default __webpack_public_path__ + "static/prog21-gate-7e1cf6fb525f5e3148d57a9839d0976d.svg";